import Cookie from 'js-cookie';

import { COOKIE_CONSENT } from '../constants/cookies';


export const getCookieConsent = () => {
  const defaultCookieConsent = {
    analytics: false,
    marketing: false,
  };

  const cookieValue = Cookie.get(COOKIE_CONSENT);

  if (typeof cookieValue !== 'string') {
    return defaultCookieConsent;
  }

  try {
    const consent = JSON.parse(cookieValue);

    return {
      analytics: consent.analytics === true,
      marketing: consent.marketing === true,
    };
  } catch {
    return defaultCookieConsent;
  }
};

/**
 * Removes a cookie whatever domain it was set on.
 *
 * A cookie's identity is (name, domain, path), and js-cookie's remove() writes
 * an expired cookie using only the attributes it is given, defaulting to
 * `{ path: '/' }` with no domain. Google sets _ga and friends with
 * cookie_domain 'auto', which uses the registrable domain, and Meta does the
 * same for _fbp. A delete-write carrying no Domain therefore targets a
 * different, host-only cookie and leaves the real one alive until it expires
 * on its own, which for _ga is two years. Revoking consent looked like it
 * worked and did nothing.
 *
 * So try every candidate: host-only, the hostname itself, and each parent
 * suffix, with and without the leading dot. Attempts against a domain the
 * browser will not accept are ignored by it, and the loop stops before the
 * public suffix.
 */
export const removeCookieEverywhere = (name) => {
  if (typeof window === 'undefined') return;

  Cookie.remove(name);
  Cookie.remove(name, { path: '/' });

  const parts = window.location.hostname.split('.');
  for (let i = 0; i < parts.length - 1; i += 1) {
    const domain = parts.slice(i).join('.');
    Cookie.remove(name, { path: '/', domain });
    Cookie.remove(name, { path: '/', domain: `.${domain}` });
  }
};
